import store from './redux/store'
import get from 'lodash.get'

const apiBaseUrl = window._env_.API_BASE_URL

let adminAccessToken = get(store.getState(), 'adminUser.user.tokens.token', '')
store.subscribe(() => {
  const newAdminAccessToken = get(store.getState(), 'adminUser.user.tokens.token', '')
  if (adminAccessToken !== newAdminAccessToken) {
    adminAccessToken = newAdminAccessToken
  }
})

export const searchLookup = async (query) => {
  try {
    const response = await fetch(apiBaseUrl + '/_/search/lookup', {
      method: 'POST',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ query: query })
    })
    if (!response.ok) {
      throw new Error('search request failed with status: ' + response.status + ', ' + response.json)
    }
    return response.json()
  } catch (e) {
    throw new Error('search request failed: ' + e.message)
  }
}

export const getItem = async (id) => {
  try {
    const response = await fetch(apiBaseUrl + '/' + id, {
      method: 'GET',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json'
      },
    })
    if (!response.ok) {
      throw new Error('request failed with status: ' + response.status + ', ' + response.json)
    }
    return response.json()
  } catch (e) {
    throw new Error('request failed: ' + e.message)
  }
}

export const getSalesToken = (token) => {
  return fetch(apiBaseUrl + '/_/subscription/sales/tokens/' + token, {
    method: 'GET',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json'
    },
  })
}

export const calculateShoppingBasket = (items, abortController = new AbortController()) => {
  let body = {
    items: items
  }
  const fetchPromise = fetch(apiBaseUrl + '/_/subscription/calculate/shoppingBasket', {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json'
    },
    signal: abortController.signal,
    body: JSON.stringify(body)
  }).then((response) => {
    if (!response.ok) {
      throw new Error('request failed with status: ' + response.status + ', ' + response.json)
    }
    return response.json()
  })
  return { fetchPromise, abortController }
}

export const calculateInvoice = (items, countryCode = null, paymentMethod = null, promotionCode = null, abortController = new AbortController()) => {
  let body = {
    items: items
  }
  if (countryCode !== null) {
    body.countryCode = countryCode
  }
  if (paymentMethod !== null) {
    body.paymentMethod = {
      type: paymentMethod
    }
  }
  if (promotionCode !== null) {
    body.promotionCode = promotionCode
  }
  const fetchPromise = fetch(apiBaseUrl + '/_/subscription/calculate/billing', {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json'
    },
    signal: abortController.signal,
    body: JSON.stringify(body)
  }).then((response) => {
    if (!response.ok) {
      throw new Error('request failed with status: ' + response.status + ', ' + response.json)
    }
    return response.json()
  })
  return { fetchPromise, abortController }
}

export const getCountries = async () => {
  try {
    const response = await fetch(apiBaseUrl + '/_/subscription/countries', {
      method: 'GET',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json'
      },
    })
    if (!response.ok) {
      throw new Error('request failed with status: ' + response.status + ', ' + response.json)
    }
    return response.json()
  } catch (e) {
    throw new Error('request failed: ' + e.message)
  }
}

export const getPropertyAddress = async (id) => {
  try {
    const response = await fetch(apiBaseUrl + '/_/subscription/properties/' + id + '/address', {
      method: 'GET',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json'
      },
    })
    if (!response.ok) {
      throw new Error('request failed with status: ' + response.status + ', ' + response.json)
    }
    return response.json()
  } catch (e) {
    throw new Error('request failed: ' + e.message)
  }
}

export const postSubscription = async (body) => {
  try {
    const response = await fetch(apiBaseUrl + '/_/subscription/subscriptions', {
      method: 'POST',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    })
    if (!response.ok) {
      throw new Error('search request failed with status: ' + response.status + ', ' + response.json)
    }
    return response.json()
  } catch (e) {
    throw new Error('search request failed: ' + e.message)
  }
}

export const getPaymentMethods = (countryCode, total, locale, abortController = new AbortController()) => {
  const fetchPromise = fetch(apiBaseUrl + '/_/subscription/paymentMethods', {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      countryCode: countryCode,
      locale: locale,
      total: total
    }),
    signal: abortController.signal,
  }).then((response) => {
    if (!response.ok) {
      throw new Error('request failed with status: ' + response.status + ', ' + response.json)
    }
    return response.json()
  })
  return { fetchPromise, abortController }
}

// Admin

export const adminLogin = (username, password, abortController = new AbortController()) => {
  const fetchPromise = fetch(apiBaseUrl + '/authenticate', {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json'
    },
    signal: abortController.signal,
    body: JSON.stringify({
      username: username,
      password: password
    })
  }).then((response) => {
    if (!response.ok) {
      throw new Error('request failed with status: ' + response.status + ', ' + response.json)
    }
    return response.json()
  })
  return { fetchPromise, abortController }
}

export const adminLoginRefresh = (refreshToken, abortController = new AbortController()) => {
  const fetchPromise = fetch(apiBaseUrl + '/authenticate/refresh', {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json'
    },
    signal: abortController.signal,
    body: JSON.stringify({
      refreshToken: refreshToken
    })
  }).then((response) => {
    if (!response.ok) {
      throw new Error('request failed with status: ' + response.status + ', ' + response.json)
    }
    return response.json()
  })
  return { fetchPromise, abortController }
}

export const adminGetSubscriptions = (searchOptions, abortController = new AbortController()) => {
  if (Object.keys(searchOptions.filter).length === 0) {
    delete searchOptions.filter
  }

  const fetchPromise = fetch(apiBaseUrl + '/_/subscription/subscriptions/list', {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + adminAccessToken
    },
    signal: abortController.signal,
    body: JSON.stringify(searchOptions)
  }).then((response) => {
    if (!response.ok) {
      throw new Error('request failed with status: ' + response.status + ', ' + response.json)
    }
    return response.json()
  })
  return { fetchPromise, abortController }
}

export const adminGetSubscription = (id, abortController = new AbortController()) => {
  const fetchPromise = fetch(apiBaseUrl + '/_/subscription/subscriptions/' + id, {
    method: 'GET',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + adminAccessToken
    },
    signal: abortController.signal,
  }).then((response) => {
    if (!response.ok) {
      throw new Error('request failed with status: ' + response.status + ', ' + response.json)
    }
    return response.json()
  })
  return { fetchPromise, abortController }
}

export const postSubscriptionComment = (id, comment, abortController = new AbortController()) => {
  const fetchPromise = fetch(apiBaseUrl + '/_/subscription/subscriptions/' + id + '/comments', {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + adminAccessToken
    },
    signal: abortController.signal,
    body: JSON.stringify({
      comment: comment
    })
  }).then((response) => {
    if (!response.ok) {
      throw new Error('request failed with status: ' + response.status + ', ' + response.json)
    }
    return response.json()
  })
  return { fetchPromise, abortController }
}

export const adminInvoicesSendUnsent = (abortController = new AbortController()) => {
  const fetchPromise = fetch(apiBaseUrl + '/_/subscription/invoices/sendUnsent', {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + adminAccessToken
    },
    signal: abortController.signal,
  }).then((response) => {
    if (!response.ok) {
      throw new Error('request failed with status: ' + response.status + ', ' + response.json)
    }
    return response.json()
  })
  return { fetchPromise, abortController }
}

export const patchSubscription = (id, patch, abortController = new AbortController()) => {
  const fetchPromise = fetch(apiBaseUrl + '/_/subscription/subscriptions/' + id, {
    method: 'PATCH',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + adminAccessToken
    },
    signal: abortController.signal,
    body: JSON.stringify(patch)
  }).then((response) => {
    if (!response.ok) {
      throw new Error('request failed with status: ' + response.status + ', ' + response.json)
    }
    return response.json()
  })
  return { fetchPromise, abortController }
}

export const adminGetSubscriptionHistory = (id, offset, limit, abortController = new AbortController()) => {
  const fetchPromise = fetch(apiBaseUrl + '/_/subscription/subscriptions/' + id + '/history/list', {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + adminAccessToken
    },
    body: JSON.stringify({
      pagination: {
        offset: offset,
        limit: limit
      }
    }),
    signal: abortController.signal,
  }).then((response) => {
    if (!response.ok) {
      throw new Error('request failed with status: ' + response.status + ', ' + response.json)
    }
    return response.json()
  })
  return { fetchPromise, abortController }
}

export const createPaymentLinkForInvoice = (id, abortController = new AbortController()) => {
  const fetchPromise = fetch(apiBaseUrl + '/_/subscription/invoices/' + id + '/paymentLink', {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + adminAccessToken
    },
    signal: abortController.signal
  }).then((response) => {
    if (!response.ok) {
      throw new Error('request failed with status: ' + response.status + ', ' + response.json)
    }
    return response.json()
  })
  return { fetchPromise, abortController }
}

export const createWinlineId = (customerId, abortController = new AbortController()) => {
  const fetchPromise = fetch(apiBaseUrl + '/_/subscription/winlineIds', {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + adminAccessToken
    },
    body: JSON.stringify({
      customerId: customerId
    }),
    signal: abortController.signal
  }).then((response) => {
    if (!response.ok) {
      throw new Error('request failed with status: ' + response.status + ', ' + response.json)
    }
    return response.json()
  })
  return { fetchPromise, abortController }
}

export const saveCustomer = (customerId, customer, abortController = new AbortController()) => {
  const fetchPromise = fetch(apiBaseUrl + '/_/subscription/customers/' + customerId, {
    method: 'PUT',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + adminAccessToken
    },
    body: JSON.stringify(customer),
    signal: abortController.signal
  }).then((response) => {
    if (!response.ok) {
      throw new Error('request failed with status: ' + response.status + ', ' + response.json)
    }
    return response.json()
  })
  return { fetchPromise, abortController }
}

export const postRequestCancellation = (email, abortController = new AbortController()) => {
  const fetchPromise = fetch(apiBaseUrl + '/_/subscription/cancellation/', {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ email }),
    signal: abortController.signal
  }).then((response) => {
    if (!response.ok) {
      throw new Error('request failed with status: ' + response.status)
    }
    return
  })
  return { fetchPromise, abortController }
}

export const getCancellation = (token, abortController = new AbortController()) => {
  const fetchPromise = fetch(apiBaseUrl + '/_/subscription/cancellation/' + token, {
    method: 'GET',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json'
    },
    signal: abortController.signal
  }).then((response) => {
    return response;
  })
  return { fetchPromise, abortController }
}

export const confirmCancellation = (token, abortController = new AbortController()) => {
  const fetchPromise = fetch(apiBaseUrl + '/_/subscription/cancellation/' + token + '/confirm', {
    method: 'GET',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json'
    },
    signal: abortController.signal
  }).then((response) => {
    if (!response.ok) {
      throw new Error('request failed with status: ' + response.status)
    }
    return response
  })
  return { fetchPromise, abortController }
}

export const adminGetSalesEmployees = (abortController = new AbortController()) => {
  const fetchPromise = fetch(apiBaseUrl + '/_/subscription/sales/employees', {
    method: 'GET',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + adminAccessToken
    },
    signal: abortController.signal,
  }).then((response) => {
    if (!response.ok) {
      throw new Error('request failed with status: ' + response.status + ', ' + response.json)
    }
    return response.json()
  })
  return { fetchPromise, abortController }
}

export const adminPostEmployee = (employee, abortController = new AbortController()) => {
  const fetchPromise = fetch(apiBaseUrl + '/_/subscription/sales/employees', {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + adminAccessToken
    },
    signal: abortController.signal,
    body: JSON.stringify(employee)
  }).then((response) => {
    if (!response.ok) {
      throw new Error('request failed with status: ' + response.status + ', ' + response.json)
    }
    return response.json()
  })
  return { fetchPromise, abortController }
}

export const adminGetEmployee = (id, abortController = new AbortController()) => {
  const fetchPromise = fetch(apiBaseUrl + '/_/subscription/sales/employees/' + id, {
    method: 'GET',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + adminAccessToken
    },
    signal: abortController.signal
  }).then((response) => {
    if (!response.ok) {
      throw new Error('request failed with status: ' + response.status + ', ' + response.json)
    }
    return response.json()
  })
  return { fetchPromise, abortController }
}

export const adminPutEmployee = (id, employee, abortController = new AbortController()) => {
  const fetchPromise = fetch(apiBaseUrl + '/_/subscription/sales/employees/' + id, {
    method: 'PUT',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + adminAccessToken
    },
    signal: abortController.signal,
    body: JSON.stringify(employee)
  }).then((response) => {
    if (!response.ok) {
      throw new Error('request failed with status: ' + response.status + ', ' + response.json)
    }
    return response.json()
  })
  return { fetchPromise, abortController }
}

export const adminGetEmployeeSalesTokens = (id, abortController = new AbortController()) => {
  const fetchPromise = fetch(apiBaseUrl + '/_/subscription/sales/employees/' + id + '/tokens', {
    method: 'GET',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + adminAccessToken
    },
    signal: abortController.signal
  }).then((response) => {
    if (!response.ok) {
      throw new Error('request failed with status: ' + response.status + ', ' + response.json)
    }
    return response.json()
  })
  return { fetchPromise, abortController }
}

export const adminPatchSalesToken = (id, patch, abortController = new AbortController()) => {
  const fetchPromise = fetch(apiBaseUrl + '/_/subscription/sales/tokens/' + id, {
    method: 'PATCH',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + adminAccessToken
    },
    signal: abortController.signal,
    body: JSON.stringify(patch)
  }).then((response) => {
    if (!response.ok) {
      throw new Error('request failed with status: ' + response.status + ', ' + response.json)
    }
    return response.json()
  })
  return { fetchPromise, abortController }
}

export const adminGetSubscriptionItems = (id, abortController = new AbortController()) => {
  const fetchPromise = fetch(apiBaseUrl + '/_/subscription/subscriptions/' + id + '/items', {
    method: 'GET',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + adminAccessToken
    },
    signal: abortController.signal
  }).then((response) => {
    if (!response.ok) {
      throw new Error('request failed with status: ' + response.status + ', ' + response.json)
    }
    return response.json()
  })
  return { fetchPromise, abortController }
}

export const adminGetComments = (orderId, abortController = new AbortController()) => {
  const fetchPromise = fetch(apiBaseUrl + '/_/subscription/subscriptions/' + orderId + '/comments', {
    method: 'GET',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + adminAccessToken
    },
    signal: abortController.signal
  }).then((response) => {
    if (!response.ok) {
      throw new Error('request failed with status: ' + response.status + ', ' + response.json)
    }
    return response.json()
  })
  return { fetchPromise, abortController }
}

export const adminGetInvoices = (orderId, abortController = new AbortController()) => {
  const fetchPromise = fetch(apiBaseUrl + '/_/subscription/subscriptions/' + orderId + '/invoices', {
    method: 'GET',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + adminAccessToken
    },
    signal: abortController.signal
  }).then((response) => {
    if (!response.ok) {
      throw new Error('request failed with status: ' + response.status + ', ' + response.json)
    }
    return response.json()
  })
  return { fetchPromise, abortController }
}

export const adminGetInvoiceItems = (invoiceId, abortController = new AbortController()) => {
  const fetchPromise = fetch(apiBaseUrl + '/_/subscription/invoices/' + invoiceId + '/items', {
    method: 'GET',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + adminAccessToken
    },
    signal: abortController.signal
  }).then((response) => {
    if (!response.ok) {
      throw new Error('request failed with status: ' + response.status + ', ' + response.json)
    }
    return response.json()
  })
  return { fetchPromise, abortController }
}

export const adminGetInvoiceBilling = (invoiceId, abortController = new AbortController()) => {
  const fetchPromise = fetch(apiBaseUrl + '/_/subscription/invoices/' + invoiceId + '/billing', {
    method: 'GET',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + adminAccessToken
    },
    signal: abortController.signal
  }).then((response) => {
    if (!response.ok) {
      throw new Error('request failed with status: ' + response.status + ', ' + response.json)
    }
    return response.json()
  })
  return { fetchPromise, abortController }
}
